const campaignTypes = {
    BLOCKWISE: 'blockwise',
    PULSE: 'pulse',
  };
  
const isActiveTypes = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    ALL: 'all',
};
  
  
  export {
    campaignTypes,
    isActiveTypes,
  };
  